import React from 'react';
import { Button, Select } from 'common/components';
import { testSpamCarrier } from 'services/api/PhoneNumberAPI';
import { Tenant } from 'types/accessManager.type';
import styles from '../PhoneNumberManager.module.scss';

interface TestCarrierTabProps {
    tenants: Tenant[];
    isAccessManagerLoading: boolean;
    showNotification: (message: string, type: 'success' | 'error') => void;
}

const TestCarrierTab: React.FC<TestCarrierTabProps> = ({ tenants, isAccessManagerLoading, showNotification }) => {
    const [testTenantId, setTestTenantId] = React.useState<string>('');

    const handleTest = () => {
        testSpamCarrier({ tenantId: testTenantId || undefined });
        showNotification('Spam carrier test initiated. This will take several minutes to complete.', 'success');
    };

    return (
        <div className={styles.testContainer}>
            <div className={styles.formSection}>
                <h2 className={styles.sectionTitle}>Test Spam Carrier</h2>
                <p className={styles.description}>
                    Initiate a spam carrier test in production. This request will take several minutes to complete. You
                    can optionally select a tenant to test specific phone numbers.
                </p>

                <div className={styles.formGroup}>
                    <Select
                        label='Tenant (Optional)'
                        options={[
                            { value: '', label: 'All Tenants' },
                            ...(tenants || []).map((tenant) => ({
                                value: tenant.id,
                                label: tenant.name,
                            })),
                        ]}
                        value={testTenantId}
                        onChange={(e) => setTestTenantId(e.target.value)}
                        disabled={isAccessManagerLoading}
                    />
                </div>

                <div className={styles.buttonContainer}>
                    <Button variant='primary' disabled={isAccessManagerLoading} onClick={handleTest}>
                        Test
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TestCarrierTab;
